
import CoreButton from './coreButton';

export default CoreButton;
